var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/material/styles';
import { inputBaseClasses } from '@mui/material/InputBase';
import { inputLabelClasses } from '@mui/material/InputLabel';
import { filledInputClasses } from '@mui/material/FilledInput';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
// ----------------------------------------------------------------------
export function textField(theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var color = {
        focused: theme.palette.text.primary,
        active: theme.palette.text.secondary,
        placeholder: theme.palette.text.disabled
    };
    var font = {
        label: theme.typography.body1,
        value: theme.typography.body2
    };
    return {
        // HELPER
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginTop: theme.spacing(1)
                }
            }
        },
        // LABEL
        MuiFormLabel: {
            styleOverrides: {
                root: __assign(__assign({}, font.value), (_a = { color: color.placeholder }, _a["&.".concat(inputLabelClasses.shrink)] = __assign(__assign({}, font.label), (_b = { fontWeight: 600, color: color.active }, _b["&.".concat(inputLabelClasses.focused)] = {
                    color: color.focused
                }, _b["&.".concat(inputLabelClasses.error)] = {
                    color: theme.palette.error.main
                }, _b["&.".concat(inputLabelClasses.disabled)] = {
                    color: theme.palette.text.disabled
                }, _b["&.".concat(inputLabelClasses.filled)] = {
                    transform: 'translate(12px, 6px) scale(0.75)'
                }, _b)), _a))
            }
        },
        // BASE
        MuiInputBase: {
            styleOverrides: {
                root: (_c = {},
                    _c["&.".concat(inputBaseClasses.disabled)] = {
                        '& svg': {
                            color: theme.palette.text.disabled
                        }
                    },
                    _c),
                input: __assign(__assign({}, font.value), { '&::placeholder': {
                        opacity: 1,
                        color: color.placeholder
                    } })
            }
        },
        // STANDARD
        MuiInput: {
            styleOverrides: {
                underline: {
                    '&:before': {
                        borderBottomColor: alpha(theme.palette.grey[500], 0.32)
                    },
                    '&:after': {
                        borderBottomColor: color.focused
                    }
                }
            }
        },
        // OUTLINED
        MuiOutlinedInput: {
            styleOverrides: {
                root: (_d = {},
                    _d["&.".concat(outlinedInputClasses.focused)] = (_e = {},
                        _e["& .".concat(outlinedInputClasses.notchedOutline)] = {
                            borderColor: color.focused
                        },
                        _e),
                    _d["&.".concat(outlinedInputClasses.error)] = (_f = {},
                        _f["& .".concat(outlinedInputClasses.notchedOutline)] = {
                            borderColor: theme.palette.error.main
                        },
                        _f),
                    _d["&.".concat(outlinedInputClasses.disabled)] = (_g = {},
                        _g["& .".concat(outlinedInputClasses.notchedOutline)] = {
                            borderColor: theme.palette.action.disabledBackground
                        },
                        _g),
                    _d.borderRadius = 8,
                    _d),
                notchedOutline: {
                    borderColor: alpha(theme.palette.grey[500], 0.2),
                    transition: theme.transitions.create(['border-color'], {
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        },
        // FILLED
        MuiFilledInput: {
            styleOverrides: {
                root: (_h = {
                        borderRadius: theme.shape.borderRadius,
                        backgroundColor: alpha(theme.palette.grey[500], 0.08),
                        '&:hover': {
                            backgroundColor: alpha(theme.palette.grey[500], 0.16)
                        }
                    },
                    _h["&.".concat(filledInputClasses.focused)] = {
                        backgroundColor: alpha(theme.palette.grey[500], 0.16)
                    },
                    _h["&.".concat(filledInputClasses.error)] = (_j = {
                            backgroundColor: alpha(theme.palette.error.main, 0.08)
                        },
                        _j["&.".concat(filledInputClasses.focused)] = {
                            backgroundColor: alpha(theme.palette.error.main, 0.16)
                        },
                        _j),
                    _h["&.".concat(filledInputClasses.disabled)] = {
                        backgroundColor: theme.palette.action.disabledBackground
                    },
                    _h)
            }
        }
    };
}
